import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUpdateTemplateStatus = createSelector(
  [(store: RootState) => store.templateDetail.updateTemplateStatus],
  (update) => update
);
